<template>
  <div>
    <Header :title="'历史详情'"/>
    <van-panel>
       <div slot="header" class="heder">
         <div class="header-wraper">
           <div class="left-part">
             <div>工单编号：{{info.orderId}}</div>
             <div>登记日期:{{info.registerDate}}</div>
             <!-- <div v-if="this.$route.params.type == 2 || this.$route.params.type == 3">处理日期:2020-02-02 12:00:00</div>
             <div v-if="this.$route.params.type == 3">完成日期:2020-02-02 12:00:00</div>
             <div v-if="this.$route.params.type == 2 || this.$route.params.type == 3">处理客户:程文洁</div>
             <div v-if="this.$route.params.type == 2 || this.$route.params.type == 3">客服QQ:1234567</div> -->
           </div>
            <div :class="{'right-part':true,'type-color-ntpro': this.$route.params.type == '待处理','type-color-onpro': this.$route.params.type== '已处理' ,'type-color-donepro':this.$route.params.type == '已完成'}">
              {{this.$route.params.type}}
            </div>
         </div>
        </div>
       <div slot="footer" class="ques">
          <!-- <div class="ques-title">
            问题原因：XXXXXXXXXX
          </div> -->
          <div class="fix-methods" v-if="this.$route.params.type == '已完成'">
            解决方案：{{info.wenthf}}
          </div>
        </div>
       <div slot="footer" class="ques-detal">
          <div class="ques-title">
            问题：{{info.orderTitle}}
          </div>
          <div class="fix-methods">
            详细描述：{{info.orderDesc}}
          </div>
          <div class="info-area">
            <div>单位名称：{{info.registerEnterprise}}</div>
            <div>联系电话：{{info.egistererTel}}</div>
            <div>联系QQ：{{info.otherContact}}</div>
          </div>
          <div class="ques-img" v-if="info.img!= null && info.img!=''">
            <div><span style="display:block;margin:2px 0 6px 0;">图片：</span><img :src="item" alt="" v-for="(item,index) in fileList" :key="index" preview="2"/></div>
          </div>
          <div class="ques-img"  v-if="info.vedio!=null">
            <div><span style="display:block;margin:2px 0 6px 0;" >视频：</span><video id="videoId" controls width="100%" :src="tvsrc"></video></div>
          </div>
          <div class="info-area" v-if="info.evaluateStar!=null && info.evaluateStar!=''">
            <div>评分：
              <van-rate
            v-model="info.evaluateStar"
            :size="21"
            color="#ffd21e"
            void-icon="star"
            void-color="#eee" class="pjright" readonly/></div>
          </div>
          <div class="info-area" v-if="info.orderEvaluate!='' && info.orderEvaluate!=null">
            <div>评价内容：{{info.orderEvaluate}}</div>
          </div>
          <div class="info-area" v-if="info.orderReply!='' && info.orderReply!=null">
            <div>回复内容：{{info.orderReply}}</div>
          </div>
          <div class="info-area" v-if="info.replyImg!='null'&&info.replyImg!=''&&info.replyImg!=null">
              <div>
                <span style="display:block;margin:2px 0 6px 0;">回复图片：</span>
                <img style="width:100px;height:100px;margin-right: 4px;" :src="item" alt="" v-for="(item,index) in replayList" :key="index" preview="2"/>
              </div>
          </div>
          <div class="info-area" v-if="info.wordDoc!='' && info.wordDoc!='null'&&info.wordDoc!=null">
            <div @click="openWord">
              <span>回复文档:</span>
              <span class="span_btn" @click="openDwon(item)" v-for="(item,index) in wordList" :key="index">附件{{index+1}}</span>
              <!-- <span style="color:#666;">下载文档</span> -->
            </div>
          </div>
        </div>
    </van-panel>
  </div>
</template>

<script>
import { Tab, Tabs ,Panel} from 'vant';
import { Rate } from 'vant';
import { mapState } from 'vuex'
import Header from '../../components/backheader.vue'
  export default {
    computed: {
      ...mapState({
      'userinfo': state=>state.user.userinfo
      })
    },
    mounted(){
      // console.log("22222222222")
      this.index()
      setTimeout(() => {
        this.openWord()
      }, 100);
    },
    components : {
      [Tabs.name]:Tabs,
      [Panel.name]:Panel,
      [Tab.name]:Tab,
      [Rate.name]:Rate,
      Header
    },
    data(){
      return {
        info : {},
        tvsrc:"",
        fileList:[],
        replayList:[],
        wordList:[],
        // nameList:[]
      }
    },
    methods : {
      openDwon(item) {
        window.open(item)
      },
      openWord () {
        var _this = this
        // console.log(this.info.wordDoc)
        if(this.info.wordDoc != null && this.info.wordDoc != ''){
          if(this.info.wordDoc.indexOf(",")>-1){
            this.wordList = []
            var list = this.info.wordDoc.split(",")
            list.map(function(res1){
              _this.wordList.push(window.g.uploadUrl+res1)
            })
          }else{
            this.wordList = [window.g.uploadUrl+this.info.wordDoc]
            // window.open(`${window.g.uploadUrl+this.info.wordDoc}`)
          }
        }
      },
      async index() {
        var _this = this
        const res = await this.$http.get(`/mobile/order/detail`,{ params : {
          orderId : this.$route.params.id
        },headers: { Authorization: "Bearer " + this.$cookies.get('token')}}).then((data)=> data.data)
        this.info = res.data
     
        this.tvsrc = window.g.uploadUrl+res.data.vedio
        if(res.data.img != null && res.data.img != '') {
          if(res.data.img.indexOf(",")>-1){
            this.fileList = []
            var list = res.data.img.split(",")
            list.map(function(res1){
              _this.fileList.push(window.g.uploadUrl+res1)
            })
          
            // console.log(this.fileList)
          }else{
            this.fileList = [window.g.uploadUrl+res.data.img]
          }
        }
        if(res.data.replyImg != null && res.data.replyImg != '') {
          if(res.data.replyImg.indexOf(",")>-1){
            this.replayList = []
            var list = res.data.replyImg.split(",")
            list.map(function(res1){
              _this.replayList.push(window.g.uploadUrl+res1)
            })
            // console.log(this.replayList)
          }else{
            this.replayList = [window.g.uploadUrl+res.data.replyImg]
          }
        }
        
        // console.log(window.g.uploadUrl+res.data.vedio)
        this.$nextTick(()=>{
           this.$previewRefresh();
        })
      }
    }
  }
</script>

<style scoped>
.header-wraper{
    position: relative;
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    box-sizing: border-box;
    width: 100%;
    padding: 10px 16px;
    overflow: hidden;
    color: #323233;
    font-size: 14px;
    line-height: 24px;
    background-color: #fff;
}
.left-part{
  width: 286px;
  flex: 0 0 auto;
}
.right-part{
  position: relative;
  overflow: hidden;
  text-align: right;
  vertical-align: middle;
  word-wrap: break-word;
}
.type-color-ntpro{
  color : #00b949;
}
#videoId{
  width: 200px;
  height: 160px;
}
.type-color-onpro{
  color : #ff8300;
}
.type-color-donepro{
  color : #ff0000;
}
.ques-title{
  font-family: PingFangSC;
  font-weight: 500;
  font-size: 14px;
  color: rgb(16, 16, 16);
  font-style: normal;
  letter-spacing: 0px;
  line-height: 20px;
  text-decoration: none;
}
.fix-methods{
  padding-top : 10px;
  font-family: PingFangSC;
  font-weight: 400;
  font-size: 14px;
  color: rgb(16, 16, 16);
  word-wrap:break-word;
}
.ques{
  margin-bottom : 20px;
}
.ques-img{
  margin-top : 20px;
}
.ques-img img{
  width : 31%;
  margin : 10px 2% 0 0;
  max-height: 120px;
}
.info-area{
    width: 100%;
    overflow: hidden;
    color: #323233;
    font-size: 14px;
    line-height: 24px;
    background-color: #fff;
}
.span_btn {
  margin-right:4px;

}
</style>



// WEBPACK FOOTER //
// src/pages/historydetail/index.vue